// List view retired — component intentionally renders nothing.
// Kept as a no-op export so existing call sites don't need cleanup.
interface InventoryViewToggleProps {
  className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function InventoryViewToggle(_props: InventoryViewToggleProps) {
  return null;
}
